import styled from "styled-components";
import {Close} from "styled-icons/remix-line/Close";

export const CloseIcon = styled(Close)`
  height: 32px;
  width: 32px;
  cursor: pointer;
`;
